import { render, staticRenderFns } from "./VoteLogItem.vue?vue&type=template&id=66a7e57e&scoped=true&"
import script from "./VoteLogItem.vue?vue&type=script&lang=js&"
export * from "./VoteLogItem.vue?vue&type=script&lang=js&"
import style0 from "./VoteLogItem.vue?vue&type=style&index=0&id=66a7e57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7e57e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
